module.exports = __webpack_public_path__ + "img/14.fbe9ba25.svg";